import { useCallback, useEffect, useRef, useState } from "react";
import {
  AUTH_TOKEN_KEY,
  getSessionCredential,
  parseCredential,
  storeSessionCredential,
} from "./userData";

const useSessionCredential = () => {
  const [credential, setCredential] = useState(getSessionCredential);

  const credentialRef = useRef(credential);
  useEffect(() => {
    credentialRef.current = credential;
  }, [credential]);

  const saveCredential = useCallback((rawCredential) => {
    // storeSessionCredential stamps session_started_at (kept from the
    // existing session on a silent refresh) — the enriched copy must be the
    // one held in state so the 7-day cap sees the true sign-in time
    const newCredential = storeSessionCredential(parseCredential(rawCredential));
    setCredential(newCredential);
  }, []);

  // Cross-tab sync — the storage event only fires in the tabs that did NOT
  // make the change: adopt a token refreshed by another tab instead of
  // firing a duplicate refresh, and when another tab signs out restart
  // this one from the login screen
  useEffect(() => {
    const onStorageChange = (event) => {
      if (event.key && event.key !== AUTH_TOKEN_KEY) return;
      const next = getSessionCredential();
      if (next) {
        setCredential(next);
      } else if (credentialRef.current) {
        window.location.reload();
      }
    };
    window.addEventListener("storage", onStorageChange);
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);

  return [credential, saveCredential];
};

export default useSessionCredential;
